module.exports = __webpack_public_path__ + "media/images/body_blank_figure_front-3f3650f2877e87495285db57c21262c5.png";